import { render, staticRenderFns } from "./CytomineProject.vue?vue&type=template&id=2af91054&"
import script from "./CytomineProject.vue?vue&type=script&lang=js&"
export * from "./CytomineProject.vue?vue&type=script&lang=js&"
import style0 from "./CytomineProject.vue?vue&type=style&index=0&id=2af91054&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports